cookiesArray